const map = {
	"./account-remove.svg": 59181,
	"./account.svg": 72642,
	"./account_circle.svg": 98879,
	"./add-point.svg": 43591,
	"./applications.svg": 2682,
	"./arrow-left-simple.svg": 72693,
	"./arrow-left.svg": 75552,
	"./arrow-right-simple.svg": 87046,
	"./arrow-up.svg": 61012,
	"./arrow.svg": 39260,
	"./arrow_up.svg": 89682,
	"./attention.svg": 4369,
	"./attention_circle.svg": 97494,
	"./audio.svg": 25125,
	"./author.svg": 78342,
	"./autorenew.svg": 74995,
	"./availability/add-new-time.svg": 63729,
	"./availability/apply-to-all.svg": 77679,
	"./availability/delete.svg": 2066,
	"./back.svg": 31902,
	"./bell.svg": 83900,
	"./billing.svg": 6198,
	"./bookings.svg": 58467,
	"./bookings_payments.svg": 88657,
	"./builder/collapse.svg": 21730,
	"./builder/cue-list.svg": 83657,
	"./builder/edit.svg": 18119,
	"./builder/expand.svg": 94619,
	"./builder/remove.svg": 94987,
	"./builder/sub-point-line.svg": 11201,
	"./builder/sub-point.svg": 5364,
	"./builder/time.svg": 95764,
	"./calendar-month-outline.svg": 12181,
	"./calendar-nav.svg": 38161,
	"./calendar.svg": 77633,
	"./check-circle.svg": 69930,
	"./check.svg": 50339,
	"./clock.svg": 83265,
	"./cloud.svg": 27972,
	"./component.svg": 21170,
	"./copy.svg": 24944,
	"./coupon.svg": 29893,
	"./credit-card.svg": 21313,
	"./cross.svg": 35795,
	"./database.svg": 27936,
	"./deactivate.svg": 865,
	"./desktop.svg": 91379,
	"./direction/car.svg": 77503,
	"./down-arrow.svg": 43923,
	"./download.svg": 4139,
	"./drag-handle.svg": 70062,
	"./edit-text.svg": 92711,
	"./edit.svg": 78431,
	"./example.svg": 71673,
	"./eye.svg": 76632,
	"./eye_inactive.svg": 47494,
	"./facebook.svg": 12431,
	"./feed.svg": 81511,
	"./file.svg": 67105,
	"./filter.svg": 23885,
	"./filter/bicycle.svg": 84231,
	"./filter/bike.svg": 47381,
	"./filter/bus.svg": 39210,
	"./filter/car.svg": 52322,
	"./filter/city_bike.svg": 99891,
	"./filter/crossbike.svg": 4531,
	"./filter/e_mtb.svg": 86203,
	"./filter/educational.svg": 1997,
	"./filter/electricscooter.svg": 56486,
	"./filter/family.svg": 18210,
	"./filter/food_and_wine.svg": 60422,
	"./filter/moto.svg": 18262,
	"./filter/motoscooter.svg": 91704,
	"./filter/mountain_bike.svg": 48859,
	"./filter/nature.svg": 25071,
	"./filter/racing_bicycle.svg": 14306,
	"./filter/road_bike.svg": 93862,
	"./filter/scooter.svg": 6777,
	"./filter/sightseeing.svg": 59428,
	"./filter/sport.svg": 87882,
	"./filter/sportbike.svg": 33189,
	"./filter/walking.svg": 74137,
	"./footer.svg": 28934,
	"./hammer-wrench.svg": 77211,
	"./import.svg": 80080,
	"./info-filled.svg": 90422,
	"./information.svg": 16713,
	"./instagram.svg": 96223,
	"./invoices.svg": 32523,
	"./language.svg": 78933,
	"./levels.svg": 18258,
	"./library.svg": 33470,
	"./like.svg": 7606,
	"./list.svg": 63251,
	"./location.svg": 37338,
	"./logos/apple.svg": 27374,
	"./logos/demo.svg": 22885,
	"./logos/dgtalguide.svg": 69330,
	"./logos/facebook.svg": 41640,
	"./logos/github.svg": 59222,
	"./logos/google.svg": 15029,
	"./logos/jira.svg": 6360,
	"./logout.svg": 42529,
	"./magic-button.svg": 1501,
	"./magic-mailbox.svg": 86177,
	"./magic-stick.svg": 89149,
	"./mail.svg": 62202,
	"./map-view.svg": 19495,
	"./map/add-point.svg": 42200,
	"./map/add.svg": 44649,
	"./map/bike.svg": 36369,
	"./map/bus.svg": 78750,
	"./map/car.svg": 64017,
	"./map/crop.svg": 49788,
	"./map/cue.svg": 13265,
	"./map/cut.svg": 48876,
	"./map/cycling.svg": 76431,
	"./map/draw-line.svg": 393,
	"./map/driving.svg": 30141,
	"./map/edit-points.svg": 76412,
	"./map/import.svg": 42717,
	"./map/instruction.svg": 29031,
	"./map/layers.svg": 22152,
	"./map/line.svg": 37924,
	"./map/location.svg": 76743,
	"./map/map-marker-plus.svg": 95510,
	"./map/minus.svg": 29460,
	"./map/plus.svg": 21634,
	"./map/redo.svg": 96994,
	"./map/remove.svg": 89530,
	"./map/route-outline.svg": 80270,
	"./map/route.svg": 97747,
	"./map/settings.svg": 16145,
	"./map/style.svg": 80935,
	"./map/trash.svg": 78378,
	"./map/undo.svg": 78904,
	"./map/walk.svg": 47377,
	"./map/walking.svg": 29685,
	"./marker.svg": 40837,
	"./members.svg": 61574,
	"./menu.svg": 86266,
	"./money.svg": 74495,
	"./more.svg": 81732,
	"./payments.svg": 26746,
	"./payout.svg": 45613,
	"./pen.svg": 89446,
	"./pencil.svg": 42808,
	"./people.svg": 86646,
	"./place.svg": 32998,
	"./play.svg": 59517,
	"./plus-in-circle.svg": 27310,
	"./plus.svg": 29947,
	"./poi.svg": 57047,
	"./range.svg": 14712,
	"./report.svg": 33093,
	"./route.svg": 4384,
	"./sales-reports.svg": 46865,
	"./search-icon.svg": 7805,
	"./search.svg": 2599,
	"./settings.svg": 44672,
	"./simple-arrow.svg": 59185,
	"./small-arrow.svg": 25638,
	"./small-dgtalguide-logo.svg": 29043,
	"./star.svg": 34075,
	"./table.svg": 4575,
	"./tasks.svg": 71213,
	"./time.svg": 33724,
	"./timetable.svg": 68422,
	"./tip.svg": 9408,
	"./tours.svg": 65478,
	"./trash.svg": 25685,
	"./upload-file.svg": 45213,
	"./upload-media.svg": 64099,
	"./user.svg": 9110,
	"./users.svg": 53675,
	"./video.svg": 82518,
	"./whatsapp-filled.svg": 46128,
	"./whatsapp.svg": 90321,
	"./widget.svg": 7607,
	"./winking-face.svg": 70592,
	"./youtube.svg": 19444,
	"src/icons/account-remove.svg": 59181,
	"src/icons/account.svg": 72642,
	"src/icons/account_circle.svg": 98879,
	"src/icons/add-point.svg": 43591,
	"src/icons/applications.svg": 2682,
	"src/icons/arrow-left-simple.svg": 72693,
	"src/icons/arrow-left.svg": 75552,
	"src/icons/arrow-right-simple.svg": 87046,
	"src/icons/arrow-up.svg": 61012,
	"src/icons/arrow.svg": 39260,
	"src/icons/arrow_up.svg": 89682,
	"src/icons/attention.svg": 4369,
	"src/icons/attention_circle.svg": 97494,
	"src/icons/audio.svg": 25125,
	"src/icons/author.svg": 78342,
	"src/icons/autorenew.svg": 74995,
	"src/icons/availability/add-new-time.svg": 63729,
	"src/icons/availability/apply-to-all.svg": 77679,
	"src/icons/availability/delete.svg": 2066,
	"src/icons/back.svg": 31902,
	"src/icons/bell.svg": 83900,
	"src/icons/billing.svg": 6198,
	"src/icons/bookings.svg": 58467,
	"src/icons/bookings_payments.svg": 88657,
	"src/icons/builder/collapse.svg": 21730,
	"src/icons/builder/cue-list.svg": 83657,
	"src/icons/builder/edit.svg": 18119,
	"src/icons/builder/expand.svg": 94619,
	"src/icons/builder/remove.svg": 94987,
	"src/icons/builder/sub-point-line.svg": 11201,
	"src/icons/builder/sub-point.svg": 5364,
	"src/icons/builder/time.svg": 95764,
	"src/icons/calendar-month-outline.svg": 12181,
	"src/icons/calendar-nav.svg": 38161,
	"src/icons/calendar.svg": 77633,
	"src/icons/check-circle.svg": 69930,
	"src/icons/check.svg": 50339,
	"src/icons/clock.svg": 83265,
	"src/icons/cloud.svg": 27972,
	"src/icons/component.svg": 21170,
	"src/icons/copy.svg": 24944,
	"src/icons/coupon.svg": 29893,
	"src/icons/credit-card.svg": 21313,
	"src/icons/cross.svg": 35795,
	"src/icons/database.svg": 27936,
	"src/icons/deactivate.svg": 865,
	"src/icons/desktop.svg": 91379,
	"src/icons/direction/car.svg": 77503,
	"src/icons/down-arrow.svg": 43923,
	"src/icons/download.svg": 4139,
	"src/icons/drag-handle.svg": 70062,
	"src/icons/edit-text.svg": 92711,
	"src/icons/edit.svg": 78431,
	"src/icons/example.svg": 71673,
	"src/icons/eye.svg": 76632,
	"src/icons/eye_inactive.svg": 47494,
	"src/icons/facebook.svg": 12431,
	"src/icons/feed.svg": 81511,
	"src/icons/file.svg": 67105,
	"src/icons/filter.svg": 23885,
	"src/icons/filter/bicycle.svg": 84231,
	"src/icons/filter/bike.svg": 47381,
	"src/icons/filter/bus.svg": 39210,
	"src/icons/filter/car.svg": 52322,
	"src/icons/filter/city_bike.svg": 99891,
	"src/icons/filter/crossbike.svg": 4531,
	"src/icons/filter/e_mtb.svg": 86203,
	"src/icons/filter/educational.svg": 1997,
	"src/icons/filter/electricscooter.svg": 56486,
	"src/icons/filter/family.svg": 18210,
	"src/icons/filter/food_and_wine.svg": 60422,
	"src/icons/filter/moto.svg": 18262,
	"src/icons/filter/motoscooter.svg": 91704,
	"src/icons/filter/mountain_bike.svg": 48859,
	"src/icons/filter/nature.svg": 25071,
	"src/icons/filter/racing_bicycle.svg": 14306,
	"src/icons/filter/road_bike.svg": 93862,
	"src/icons/filter/scooter.svg": 6777,
	"src/icons/filter/sightseeing.svg": 59428,
	"src/icons/filter/sport.svg": 87882,
	"src/icons/filter/sportbike.svg": 33189,
	"src/icons/filter/walking.svg": 74137,
	"src/icons/footer.svg": 28934,
	"src/icons/hammer-wrench.svg": 77211,
	"src/icons/import.svg": 80080,
	"src/icons/info-filled.svg": 90422,
	"src/icons/information.svg": 16713,
	"src/icons/instagram.svg": 96223,
	"src/icons/invoices.svg": 32523,
	"src/icons/language.svg": 78933,
	"src/icons/levels.svg": 18258,
	"src/icons/library.svg": 33470,
	"src/icons/like.svg": 7606,
	"src/icons/list.svg": 63251,
	"src/icons/location.svg": 37338,
	"src/icons/logos/apple.svg": 27374,
	"src/icons/logos/demo.svg": 22885,
	"src/icons/logos/dgtalguide.svg": 69330,
	"src/icons/logos/facebook.svg": 41640,
	"src/icons/logos/github.svg": 59222,
	"src/icons/logos/google.svg": 15029,
	"src/icons/logos/jira.svg": 6360,
	"src/icons/logout.svg": 42529,
	"src/icons/magic-button.svg": 1501,
	"src/icons/magic-mailbox.svg": 86177,
	"src/icons/magic-stick.svg": 89149,
	"src/icons/mail.svg": 62202,
	"src/icons/map-view.svg": 19495,
	"src/icons/map/add-point.svg": 42200,
	"src/icons/map/add.svg": 44649,
	"src/icons/map/bike.svg": 36369,
	"src/icons/map/bus.svg": 78750,
	"src/icons/map/car.svg": 64017,
	"src/icons/map/crop.svg": 49788,
	"src/icons/map/cue.svg": 13265,
	"src/icons/map/cut.svg": 48876,
	"src/icons/map/cycling.svg": 76431,
	"src/icons/map/draw-line.svg": 393,
	"src/icons/map/driving.svg": 30141,
	"src/icons/map/edit-points.svg": 76412,
	"src/icons/map/import.svg": 42717,
	"src/icons/map/instruction.svg": 29031,
	"src/icons/map/layers.svg": 22152,
	"src/icons/map/line.svg": 37924,
	"src/icons/map/location.svg": 76743,
	"src/icons/map/map-marker-plus.svg": 95510,
	"src/icons/map/minus.svg": 29460,
	"src/icons/map/plus.svg": 21634,
	"src/icons/map/redo.svg": 96994,
	"src/icons/map/remove.svg": 89530,
	"src/icons/map/route-outline.svg": 80270,
	"src/icons/map/route.svg": 97747,
	"src/icons/map/settings.svg": 16145,
	"src/icons/map/style.svg": 80935,
	"src/icons/map/trash.svg": 78378,
	"src/icons/map/undo.svg": 78904,
	"src/icons/map/walk.svg": 47377,
	"src/icons/map/walking.svg": 29685,
	"src/icons/marker.svg": 40837,
	"src/icons/members.svg": 61574,
	"src/icons/menu.svg": 86266,
	"src/icons/money.svg": 74495,
	"src/icons/more.svg": 81732,
	"src/icons/payments.svg": 26746,
	"src/icons/payout.svg": 45613,
	"src/icons/pen.svg": 89446,
	"src/icons/pencil.svg": 42808,
	"src/icons/people.svg": 86646,
	"src/icons/place.svg": 32998,
	"src/icons/play.svg": 59517,
	"src/icons/plus-in-circle.svg": 27310,
	"src/icons/plus.svg": 29947,
	"src/icons/poi.svg": 57047,
	"src/icons/range.svg": 14712,
	"src/icons/report.svg": 33093,
	"src/icons/route.svg": 4384,
	"src/icons/sales-reports.svg": 46865,
	"src/icons/search-icon.svg": 7805,
	"src/icons/search.svg": 2599,
	"src/icons/settings.svg": 44672,
	"src/icons/simple-arrow.svg": 59185,
	"src/icons/small-arrow.svg": 25638,
	"src/icons/small-dgtalguide-logo.svg": 29043,
	"src/icons/star.svg": 34075,
	"src/icons/table.svg": 4575,
	"src/icons/tasks.svg": 71213,
	"src/icons/time.svg": 33724,
	"src/icons/timetable.svg": 68422,
	"src/icons/tip.svg": 9408,
	"src/icons/tours.svg": 65478,
	"src/icons/trash.svg": 25685,
	"src/icons/upload-file.svg": 45213,
	"src/icons/upload-media.svg": 64099,
	"src/icons/user.svg": 9110,
	"src/icons/users.svg": 53675,
	"src/icons/video.svg": 82518,
	"src/icons/whatsapp-filled.svg": 46128,
	"src/icons/whatsapp.svg": 90321,
	"src/icons/widget.svg": 7607,
	"src/icons/winking-face.svg": 70592,
	"src/icons/youtube.svg": 19444
};



function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then((id) => (__webpack_require__(id)));
}
function webpackAsyncContextResolve(req) {
	return Promise.all(/* lazy-once context */[__webpack_require__.e(229), __webpack_require__.e(9488)]).then(() => {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 38692;
module.exports = webpackAsyncContext;